document.addEventListener("DOMContentLoaded", () => {
    const continueStepOneBtns = document.querySelectorAll(".arbres-fruitiers button.continue, .fixed-btn button"),
        continueStepTwoToCheckout = document.querySelector(".product-step-2 button.continue"),
        productIntroTitle = document.querySelector(".product-intro-title"),
        sectionStepTwo = document.querySelector(".product-step-2"),
        stepTwoToCheckout = document.querySelector(".product-step-2-wrapper"),
        sectionProductSteps = document.querySelector(".product-steps"),
        allSectionsStep1 = document.querySelectorAll(".product-step-1"),
        iconGiftSvg = `<svg data-name="Layer 1" id="Layer_1" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="M211.86,245.66V441.83h88.29V245.71c-11.8-26.5-26.88-54.85-44.15-75.1C238.73,190.85,223.66,219.18,211.86,245.66Z"/><path d="M445.29,173.36H438a46.67,46.67,0,0,1-14.78,20.17c-.08.07-.17.12-.25.18h12.19V414.07H313.72v20.36H445.29a10.18,10.18,0,0,0,10.18-10.18V183.53A10.17,10.17,0,0,0,445.29,173.36Z"/><path d="M130.16,258l31.36-7.49,16.1,45.29c9.91-29.06,31.11-84.52,59.78-123.32h-2.78a28.81,28.81,0,0,1-20.55-8.62c-13,8.16-30.58,18.23-49,26A209.09,209.09,0,0,0,130.16,258Z"/><path d="M234.62,158.86h42.77a15.32,15.32,0,0,0,15.3-15.32V100.77a15.32,15.32,0,0,0-15.3-15.31H234.62a15.33,15.33,0,0,0-15.31,15.31v42.77A15.33,15.33,0,0,0,234.62,158.86Z"/><path d="M97.24,182.88c18.34,14.44,59.23-2.09,91.94-20.23h0c6.33-3.51,12.35-7.08,17.85-10.5a28.75,28.75,0,0,1-1.31-8.6V126.13L119.41,94.44c39.56-4,71.81,12.78,86.33,22.08V100.77a28.77,28.77,0,0,1,.44-4.85c-21.8-12.84-49.82-25.75-72-25.75-10,0-18.76,2.63-25.21,9.09C101.81,86.5,81.88,123.44,83.71,154,84.46,166.69,89,176.41,97.24,182.88Z"/><path d="M306.26,143.54a28.68,28.68,0,0,1-1.3,8.59c4,2.5,8.28,5.07,12.78,7.65l0,0c33.43,19.18,77.69,38.29,97,23.08,8.21-6.48,12.76-16.2,13.52-28.9,1.82-30.56-18.11-67.48-25.32-74.72-20.73-20.75-65.53-2-97.16,16.64a29,29,0,0,1,.44,4.87v15.76c14.51-9.3,46.77-26,86.33-22.09l-86.33,31.69Z"/><path d="M274.6,172.43c28.67,38.8,49.87,94.27,59.78,123.33l16.11-45.3L381.84,258A209.21,209.21,0,0,0,347,189.81c-18.45-7.75-36-17.83-49.07-26a28.8,28.8,0,0,1-20.55,8.62Z"/><path d="M76.88,193.71h12.2a2.15,2.15,0,0,1-.24-.18,46.45,46.45,0,0,1-14.78-20.17H66.71a10.17,10.17,0,0,0-10.18,10.17V424.25a10.18,10.18,0,0,0,10.18,10.18H198.29V414.07H76.88Z"/></svg>`;
    document.body.classList.add("ref-product"), window.location.search.includes("s=name") && (ajaxCartSetLines());
    //, (document.querySelector(".fixed-btn").style.display = "none"));
    function closeCartDrawer() {
        cartDrawer.classList.remove("active"), document.body.classList.remove("overflow-hidden");
    }
    continueStepOneBtns.forEach((btn) => {
        btn.addEventListener("click", () => {
            btn.classList.add("active-loading"), (window.location.href = window.Shopify.routes.root + "products/fruit-trees?s=name");
        });
    });
    function ajaxFirstCallAndReload() {
        const cartKeys = window.Shopify.cartKeys,
            cartLength = cartKeys.length;
        let indexChangeCall = 0;
        for (; cartKeys[indexChangeCall].named === !0; ) indexChangeCall += 1;
        changeCall(cartKeys[indexChangeCall].key);
        function changeCall(key) {
            let propertyDefaultName = "define-" + gsap.utils.random(1, 15e3, 1);
            const body = { id: key, quantity: 1, properties: { Name: propertyDefaultName } };
            fetch(window.Shopify.routes.root + "cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) })
                .then((response) => response.json())
                .then((data) => {
                    window.location.href = window.location.pathname + "?s=name&rel=true";
                });
        }
    }
    function ajaxCartSetLines(btn = null) {
        fetch(window.Shopify.routes.root + "cart.js")
            .then((response) => response.json())
            .then((data) => {
                if (
                    (() => {
                        let allIsFilled = !0;
                        for (item of data.items) {
                            if (!item.properties.Name) {
                                allIsFilled = !1;
                                break;
                            }
                            if (item.properties.Name.includes("define")) {
                                allIsFilled = !1;
                                break;
                            }
                        }
                        return allIsFilled;
                    })()
                )
                    getCookie("lastpage") == "checkout"
                        ? (window.location.href = window.Shopify.routes.root + "cart")
                        : (setCookie("lastpage", "checkout"),
                          setTimeout(() => {
                              window.location.href = window.Shopify.routes.root + "checkout";
                          }, 100));
                else {
                    (stepTwoToCheckout.innerHTML = ""), launchStepTwo(), btn && btn.classList.remove("active-loading");
                    const tooltipContent = stepTwoToCheckout.dataset.tooltip;
                    data.items.reverse().forEach((item2) => {
                        if (item2.properties.Name && !item2.properties.Name.includes("define")) return;
                        const htmlTag = document.createElement("div");
                        htmlTag.classList.add("product-name-item"), htmlTag.setAttribute("data-key", item2.key), htmlTag.setAttribute("data-quantity", item2.quantity);
                        const htmlContent = `
            <label class="fw-500 mb-15 dib fs-16" for="name-${item2.key}">Name of the owner of "${item2.product_title}"</label>
            <div class="fields df aic">
                <input placeholder="Please enter your name correctly" class="mr-30" type="text" id="name-${item2.key}" required>
                <div class="gift-checkbox">
                    <input type="checkbox" id="gift-${item2.key}">
                    <label class="df aic" for="gift-${item2.key}">
                        <span class="square"></span>
                        <span class="text fcc">
                            ${iconGiftSvg}
                            <span class="lh-0 ml-5 fw-600">Is it a gift?</span>
                      </span>
                    </label>
                </div>
                <div class="tooltip-info ml-15 pos-rel hidden">
                  <span class="text-green fw-600">What's included in the price?</span>
                  <span class="tooltip-content">${tooltipContent}</span>
                </div>
            </div>

            <div class="phone-infos mt-30 fsbc">
              <div class="phone-item" data-owner="customer">
                <div class="phone-text-content df fdc">
                    <span class="fw-500">Your telephone number</span>
                    <div class="df aic col-gap-5 mt-10 mb-15">
                        <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.0565 5.41992C5.51502 5.41992 5.13135 5.8594 5.13135 6.40034V9.73381C5.13135 10.2753 5.51502 10.714 6.0565 10.714C6.5977 10.714 6.98111 10.2753 6.98111 9.73381V6.40034C6.98111 5.85887 6.5977 5.41992 6.0565 5.41992Z" fill="#CAC9BB"/>
                            <path d="M6.06062 2.87207C5.50126 2.87207 5.04736 3.3257 5.04736 3.88533C5.04736 4.44469 5.50126 4.89805 6.06062 4.89805C6.61945 4.89805 7.07335 4.44469 7.07335 3.88533C7.07335 3.3257 6.61945 2.87207 6.06062 2.87207Z" fill="#CAC9BB"/>
                            <path d="M6.06033 0.887695C2.71831 0.887695 0 3.60654 0 6.94775C0 10.2895 2.71858 13.0078 6.06033 13.0078C9.40208 13.0078 12.1201 10.289 12.1201 6.94775C12.1201 3.60654 9.40208 0.887695 6.06033 0.887695ZM6.06033 11.687C3.44721 11.687 1.32137 9.56087 1.32137 6.94775C1.32137 4.33464 3.44721 2.2088 6.06033 2.2088C8.67317 2.2088 10.7987 4.33464 10.7987 6.94775C10.7987 9.56087 8.67317 11.687 6.06033 11.687Z" fill="#CAC9BB"/>
                            </svg>
                            <span class="text-grey">The video will be sent to you via Whatsapp</span>                            
                    </div>
                </div>

                <div class="phone-inputs">                    
                    <select class="cus-area-code area-code" id="cus-area-code" onchange="updatePrefix(this)">
                      <option value="+1" selected="selected">US(+1)</option>
                      <option value="+44">UK(+44)</option>
                      <option value="+1">CA(+1)</option>
                      <option value="+61">AUS(+61)</option>
                    </select>                    
                    <input class="phone-input prefix customer mr-5" type="tel" value="+1" oninput="this.value = this.value.replace(/[^0-9+]/g, '');" placeholder="+1" required>
                    <input class="phone-input suffix customer" type="tel" value="" placeholder="7 15 87 08 60" oninput="this.value = this.value.replace(/[^0-9 ]/g, '');" maxlength="13" required>
                </div>
            </div>

            <div class="phone-item hidden" data-owner="beneficiary">
                <div class="phone-text-content pl-5 df fdc">
                    <span class="fw-500 mt-auto mb-15">Beneficiary's telephone number</span>
                </div>

                <div class="phone-inputs">                    
                    <select class="area-code ben-area-code" id="ben-area-code" onchange="updatePrefix(this)">
                      <option value="+1" selected="selected">US(+1)</option>
                      <option value="+44">UK(+44)</option>
                      <option value="+1">CA(+1)</option>
                      <option value="+61">AUS(+61)</option>
                    </select>                    
                    <input class="phone-input prefix mr-5" type="tel" value="+1" oninput="this.value = this.value.replace(/[^0-9+]/g, '');" placeholder="+1">
                    <input class="phone-input suffix" type="tel" value="" placeholder="7 15 87 08 60" oninput="this.value = this.value.replace(/[^0-9 ]/g, '');" maxlength="13">
                </div>
            </div>
          </div>
          `;
                        (htmlTag.innerHTML = htmlContent),
                            stepTwoToCheckout.append(htmlTag),
                            continueStepTwoToCheckout.closest("div").classList.remove("hidden"),
                            document.querySelectorAll('.gift-checkbox input[type="checkbox"]').forEach((input) => {
                                input.addEventListener("change", () => {
                                    const beneficiaryField = input.closest(".product-name-item").querySelector('.phone-item[data-owner="beneficiary"]'),
                                        beneficiaryPrefix = beneficiaryField.querySelector(".phone-input.prefix"),
                                        beneficiarySuffix = beneficiaryField.querySelector(".phone-input.suffix");
                                    input.checked
                                        ? (beneficiaryField.classList.remove("hidden"), beneficiaryPrefix.setAttribute("required", ""), beneficiarySuffix.setAttribute("required", ""))
                                        : (beneficiaryField.classList.add("hidden"), beneficiaryPrefix.removeAttribute("required"), beneficiarySuffix.removeAttribute("required"));
                                });
                            });
                    });
                    const firstPrefix = document.querySelector(".phone-input.prefix"),
                        firstSuffix = document.querySelector(".phone-input.suffix");
                    let updateInputsPrefixAuthorization = !0,
                        updateInputsSuffixAuthorization = !0;
                    const updateAllInputValues = (selector, value) => {
                        document.querySelectorAll(selector).forEach((input) => {
                            input.value = value;
                        });
                    };
                    firstPrefix.addEventListener("blur", () => {
                        updateInputsPrefixAuthorization && (updateAllInputValues(".phone-input.prefix.customer", firstPrefix.value), (updateInputsPrefixAuthorization = !1));
                    }),
                        firstSuffix.addEventListener("blur", () => {
                            updateInputsSuffixAuthorization && (updateAllInputValues(".phone-input.suffix.customer", firstSuffix.value), (updateInputsSuffixAuthorization = !1));
                        }),
                        document.querySelectorAll('.fields input[type="text"], .phone-inputs input').forEach((input) => {
                            input.addEventListener("input", () => {
                                input.value.trim() == "" && (input.value = "");
                            });
                        });
                }
            });
    }
    function launchStepTwo() {
        sectionProductSteps.classList.add("is-step-2"),
            allSectionsStep1.forEach((section) => {
                section.classList.add("hidden");
            }),
            sectionStepTwo.classList.remove("hidden"),
            productIntroTitle && (productIntroTitle.innerText = productIntroTitle.dataset.stepTwo);
        const activeLinkStepTwo = document.querySelector('li a.header__menu-item[aria-current="page"]');
        activeLinkStepTwo && (activeLinkStepTwo.removeAttribute("aria-current"), activeLinkStepTwo.classList.remove("list-menu__item--active")),
            document.body.classList.remove("reload"),
            gsap.to(window, { duration: 1, ease: "power2.in", scrollTo: { y: "#form-step-name", offsetY: 250 } });
    }    
    const cartDrawer = document.querySelector("cart-drawer.drawer");
    cartDrawer &&
        cartDrawer.addEventListener("click", (e) => {
            if (e.target.classList.contains("cart__checkout-button")) {
                const btnSideCart = document.querySelector(".cart__checkout-button"),
                    sectionProductSteps2 = document.querySelector(".product-steps");
                btnSideCart.type === "button"
                    ? (ajaxCartSetLines(), closeCartDrawer2())
                    : btnSideCart.type === "submit" &&
                      (setCookie("lastpage", "checkout"),
                      setTimeout(() => {
                          window.location.href = window.Shopify.routes.root + "checkout";
                      }, 100));
            }
            function closeCartDrawer2() {
                cartDrawer.classList.remove("active"), document.body.classList.remove("overflow-hidden");
            }
        });
    const formStepTwo = document.querySelector(".form-step-2"),
        formStepTwoBtnSubmit = document.querySelector('.form-step-2 button[type="submit"]');
    formStepTwo.addEventListener("submit", (e) => {
        e.preventDefault();
        const names = formStepTwo.querySelectorAll('input[type="text"]');
        let itemsTable = [];
        names.forEach((name) => {
            const nameContainer = name.closest(".product-name-item"),
                key = nameContainer.dataset.key,
                qty = parseInt(nameContainer.dataset.quantity),
                isGift = nameContainer.querySelector('input[type="checkbox"]').checked,
                nameValue = name.value,
                customerPhone = getPhone(nameContainer.querySelector('.phone-item[data-owner="customer"]')),
                beneficiaryPhone = getPhone(nameContainer.querySelector('.phone-item[data-owner="beneficiary"]')),
                itemData = { id: key, quantity: qty, properties: { Name: nameValue, Gift: isGift ? "Yes" : null, Phone: customerPhone, Beneficiary: isGift ? beneficiaryPhone : null } };
            itemsTable.push(itemData);
            function getPhone(container) {
                const prefix = container.querySelector(".phone-input.prefix").value,
                    suffix = container.querySelector(".phone-input.suffix").value;
                return prefix + " " + suffix;
            }
        });
        let cartAPIIteration = 0;
        const itemsTableLength = itemsTable.length;
        updateCart(itemsTable[cartAPIIteration]);
        function updateCart(body) {
            formStepTwoBtnSubmit.classList.add("active-loading"),
                fetch(window.Shopify.routes.root + "cart/change.js", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) })
                    .then((response) => response.json())
                    .then((data) => {
                        (cartAPIIteration += 1),
                            cartAPIIteration < itemsTableLength
                                ? updateCart(itemsTable[cartAPIIteration])
                                : (setCookie("lastpage", "checkout"),
                                  setTimeout(() => {
                                      window.location.href = window.Shopify.routes.root + "checkout";
                                  }, 100));
                    })
                    .catch((error) => {
                        console.log(error);
                    });
        }
    });
    function getCookie(key) {
        let cookieToReturn = null;
        for (cookie of document.cookie.split(";")) {
            cookie = cookie.trim();
            const tableCookie = cookie.split("="),
                nameCookie = tableCookie[0],
                valueCookie = tableCookie[1];
            if (nameCookie === encodeURIComponent(key)) {
                cookieToReturn = valueCookie;
                break;
            }
        }
        return cookieToReturn;
    }
    function setCookie(key, value) {
        let dateCookie = new Date(new Date().getTime() + 3e5);
        document.cookie = `${encodeURIComponent(key)}=${encodeURIComponent(value)};expires=${dateCookie}`;
    }
});